import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/src/app/[locale]/PageContent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DefaultLayout"] */ "/vercel/path0/apps/web/src/app/DefaultLayout.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductCategoryPage"] */ "/vercel/path0/apps/web/src/templates/ProductCategoryPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProductListingPage"] */ "/vercel/path0/apps/web/src/templates/ProductListingPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
